"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentImageType = void 0;
var ContentImageType;
(function (ContentImageType) {
    ContentImageType["Remote"] = "remote";
})(ContentImageType = exports.ContentImageType || (exports.ContentImageType = {}));
